import { render, staticRenderFns } from "./UnitDetail.vue?vue&type=template&id=4434c75b&scoped=true"
import script from "./UnitDetail.vue?vue&type=script&lang=js"
export * from "./UnitDetail.vue?vue&type=script&lang=js"
import style0 from "./UnitDetail.vue?vue&type=style&index=0&id=4434c75b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4434c75b",
  null
  
)

export default component.exports